export default "__VITE_ASSET__oiVhxL3o__"